import { render, staticRenderFns } from "./ModuleAdd.vue?vue&type=template&id=765328a1&scoped=true"
import script from "./ModuleAdd.vue?vue&type=script&lang=js"
export * from "./ModuleAdd.vue?vue&type=script&lang=js"
import style0 from "./ModuleAdd.vue?vue&type=style&index=0&id=765328a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765328a1",
  null
  
)

export default component.exports